module.exports = __webpack_public_path__ + "pivotaltracker-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/pivotaltracker-logo.png
// module id = 1264
// module chunks = 74